<template>
  <b-modal id="editMileageRateModal" ref="editMileageRateModal" hide-header hide-footer class="edit-mileage-rate-modal">
    <div class="modal-mileage-rate-wrapper">
      <div class="">Edit MILEAGE RATE</div>
      <div class="ap-field-input-wrapper">
        <div class="title-field">MILEAGE RATE</div>
        <div class="ap-input-wrapper">
<!--          <input class="input" v-model="staffConfig.value" type="number">-->
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// import localStorageKeys from '@/utils/local-storage-keys';
// import storeConstants from '@/store/constants';
// import {mapActions} from 'vuex';
export default {
  name: `edit-mileage-rate-modal`,
  props: {
    staffConfig: {
      type: Object
    }
  },
  components: {
  },
  methods: {
    handleCancel () {
      this.$refs.editMileageRateModal.hide();
    },
    handleComleteEventClick () {
    }
  },
  created () {
  }
};
</script>



// WEBPACK FOOTER //
// EditMileageRateModal.vue?669342e6